import LocalityType from '@domain-group/fe-allhomes-library/lib/enums/locality-type';
var getValidSingleLocality = (searchQuery, singleLocalityTypes) => {
  var singleLocality = searchQuery.getSingleLocality();
  if (!singleLocality) {
    return false;
  }
  var localityType = LocalityType[singleLocality.type];
  return localityType && singleLocalityTypes.includes(localityType.type) ? singleLocality : null;
};
export default getValidSingleLocality;